import { render, staticRenderFns } from "./CustomCounterBar.vue?vue&type=template&id=b72f09cc&scoped=true&"
import script from "./CustomCounterBar.vue?vue&type=script&lang=js&"
export * from "./CustomCounterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f09cc",
  null
  
)

export default component.exports